import _ from 'lodash';

const DEFAULT_LOGS_PAGE_SIZE = 50;

const pickAny = (obj, keys) => keys.map(k => _.get(obj, k)).find(v => !_.isNil(v));

const mapLogItem = item => ({
  id: pickAny(item, ['id', 'Id']),
  createdDate: pickAny(item, ['createdDate', 'CreatedDate', 'createdAt', 'CreatedAt']),
  method: pickAny(item, ['method', 'Method']),
  url: pickAny(item, ['url', 'Url']),
  statusCode: pickAny(item, ['statusCode', 'StatusCode']),
  httpClientName: pickAny(item, ['httpClientName', 'HttpClientName', 'clientName', 'ClientName']),
  applicationId: pickAny(item, ['applicationId', 'ApplicationId']),
  requestBlobStorageId: pickAny(item, [
    'requestBlobStorageId',
    'RequestBlobStorageId',
    'requestBlobId',
    'RequestBlobId',
  ]),
  responseBlobStorageId: pickAny(item, [
    'responseBlobStorageId',
    'ResponseBlobStorageId',
    'responseBlobId',
    'ResponseBlobId',
  ]),
  metadata: pickAny(item, ['metadata', 'Metadata']),
});

export const buildRequestParams = (filters, skip = 0, take = DEFAULT_LOGS_PAGE_SIZE) => ({
  skip,
  take,
  ...(!_.isNil(filters.statusCode) && { statusCode: filters.statusCode }),
  ...(!_.isNil(filters.url) && { url: filters.url }),
  ...(!_.isNil(filters.startDate) && { startDate: filters.startDate }),
  ...(!_.isNil(filters.endDate) && { endDate: filters.endDate }),
  ...(!_.isNil(filters.applicationId) && { applicationId: filters.applicationId }),
});

export const parseLogsResponse = data => {
  const rawLogs = data?.logs;
  const logs = _.isArray(rawLogs) ? rawLogs.map(mapLogItem) : [];
  const total = data?.total ?? 0;

  return { logs, total };
};
